'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AVATAR_LOOKUP_PROPTYPES = exports.OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID = exports.OBJECT_TYPE_TO_ENDPOINT_MAPPINGS = exports.DEFAULT_MAX_UPLOAD_SIZE_MB = exports.API_IDENTIFIER_MAPPINGS = exports.API_KNOWN_VALUE_MAPPINGS = exports.API_KNOWN_KEY_MAPPINGS = exports.RETINA_MULTIPLIER = exports.AVATAR_TYPES = exports.AVATAR_SIZES = exports.SIZE_CLASSES = exports.BORDERWIDTH = exports.SOCIAL_MAP = undefined;

var _react = require('react');

var _colors = require('HubStyleTokens/colors');

var _theme = require('HubStyleTokens/theme');

var SOCIAL_MAP = exports.SOCIAL_MAP = {
  facebook: { icon: 'socialFacebook', color: _colors.FACEBOOK },
  google: { icon: 'socialGoogle', color: _colors.GOOGLE },
  googledrive: { icon: 'socialGoogleDrive', color: _colors.GOOGLE },
  googleplus: { icon: 'socialGoogleplus', color: _colors.GOOGLE },
  heart: { icon: 'socialHeart', color: _theme.CANDY_APPLE },
  instagram: { icon: 'socialInstagram', color: _theme.INSTAGRAM },
  linkedin: { icon: 'socialLinkedin', color: _theme.LINKEDIN },
  pinterest: { icon: 'socialInstagram', color: _theme.PINTEREST },
  retweet: { icon: 'socialRetweet', color: _colors.TWITTER },
  rss: { icon: 'socialRss', color: _colors.RSS },
  slack: { icon: 'socialSlack', color: _colors.FACEBOOK },
  twitter: { icon: 'socialTwitter', color: _colors.TWITTER },
  xing: { icon: 'socialXing', color: _theme.XING },
  youtube: { icon: 'socialBlockYoutubeplay', color: _theme.YOUTUBE },
  youtubeplay: { icon: 'socialYoutubeplay', color: _theme.YOUTUBE }
};

var BORDERWIDTH = exports.BORDERWIDTH = 1;

var SIZE_CLASSES = exports.SIZE_CLASSES = {
  responsive: '',
  xs: 'private-avatar--xs',
  sm: 'uiAvatarSmall private-avatar--sm',
  md: 'uiAvatarMedium private-avatar--md',
  lg: 'uiAvatarLarge private-avatar--lg',
  xl: 'uiAvatarXLarge private-avatar--xl'
};

var AVATAR_SIZES = exports.AVATAR_SIZES = {
  xxs: 16,
  xs: 24,
  sm: 32,
  md: 48,
  lg: 72,
  xl: 108,
  responsive: 'responsive'
};

var AVATAR_TYPES = exports.AVATAR_TYPES = {
  company: 'COMPANIES',
  companyId: 'COMPANIES',
  contact: 'CONTACT',
  domain: 'COMPANIES',
  email: 'CONTACT',
  emails: 'CONTACT',
  enrichmentDomain: 'COMPANIES',
  enrichmentEmail: 'CONTACT',
  hubSpotUserEmail: 'CONTACT',
  hubSpotUserEmails: 'CONTACT',
  productId: 'PRODUCT',
  vid: 'CONTACT',
  ticket: 'TICKET',
  deal: 'DEAL',
  _isHasMore: false
};

var RETINA_MULTIPLIER = exports.RETINA_MULTIPLIER = 2;
var API_KNOWN_KEY_MAPPINGS = exports.API_KNOWN_KEY_MAPPINGS = {
  contact: 'knownContacts',
  company: 'knownCompanies'
};

var API_KNOWN_VALUE_MAPPINGS = exports.API_KNOWN_VALUE_MAPPINGS = {
  contact: {
    primaryIdentifier: 'vid',
    secondaryIdentifier: 'email'
  },
  company: {
    primaryIdentifier: 'companyId',
    secondaryIdentifier: 'domain'
  }
};

var API_IDENTIFIER_MAPPINGS = exports.API_IDENTIFIER_MAPPINGS = {
  contact: 'vids',
  company: 'companyIds',
  vids: 'vids',
  vid: 'vids',
  companyId: 'companyIds',
  email: 'emails',
  domain: 'domains',
  enrichmentEmail: 'emails',
  enrichmentDomain: 'domains',
  hubSpotUserEmails: 'hubSpotUserEmails',
  hubSpotUserEmail: 'hubSpotUserEmails',
  product: 'productIds',
  productId: 'productIds',
  _isHasMore: false
};

var DEFAULT_MAX_UPLOAD_SIZE_MB = exports.DEFAULT_MAX_UPLOAD_SIZE_MB = 4;

var OBJECT_TYPE_TO_ENDPOINT_MAPPINGS = exports.OBJECT_TYPE_TO_ENDPOINT_MAPPINGS = {
  contact: 'contacts/vid',
  vid: 'contacts/vid',
  company: 'companies/companyId',
  companyId: 'companies/companyId',
  product: 'products/productId',
  productId: 'products/productId'
};

var OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID = exports.OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID = ['contact', 'vid', 'company', 'companyId', 'product', 'productId'];

var AVATAR_LOOKUP_PROPTYPES = exports.AVATAR_LOOKUP_PROPTYPES = _react.PropTypes.oneOfType([_react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['contact']).isRequired,
  primaryIdentifier: _react.PropTypes.number.isRequired,
  secondaryIdentifier: _react.PropTypes.string,
  fileManagerKey: _react.PropTypes.string,
  displayName: _react.PropTypes.string
}).isRequired, _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['company']).isRequired,
  primaryIdentifier: _react.PropTypes.number.isRequired,
  secondaryIdentifier: _react.PropTypes.string,
  fileManagerKey: _react.PropTypes.string,
  displayName: _react.PropTypes.string
}).isRequired, _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['vid']).isRequired,
  primaryIdentifier: _react.PropTypes.number.isRequired,
  displayName: _react.PropTypes.string
}).isRequired, _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['companyId']).isRequired,
  primaryIdentifier: _react.PropTypes.number.isRequired,
  displayName: _react.PropTypes.string
}).isRequired, _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['email']).isRequired,
  primaryIdentifier: _react.PropTypes.string.isRequired,
  displayName: _react.PropTypes.string
}).isRequired, _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['domain']).isRequired,
  primaryIdentifier: _react.PropTypes.string.isRequired,
  displayName: _react.PropTypes.string
}).isRequired, _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['enrichmentEmail']).isRequired,
  primaryIdentifier: _react.PropTypes.string.isRequired,
  displayName: _react.PropTypes.string
}).isRequired, _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['enrichmentDomain']).isRequired,
  primaryIdentifier: _react.PropTypes.string.isRequired,
  displayName: _react.PropTypes.string
}).isRequired, _react.PropTypes.shape({
  type: _react.PropTypes.oneOf(['hubSpotUserEmail']).isRequired,
  primaryIdentifier: _react.PropTypes.string.isRequired,
  displayName: _react.PropTypes.string
}).isRequired]);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.1456/js/Constants.js
// module id = 15
// module chunks = 171